namespace Areas.Analysis.ActiveProjects {
    "use strict";



    var tabItems = Areas.createTabsWithSameController("Analysis",
        ["All", "Capital", "Facilities", "Housing", "Medical", "RealEstate", "Other", "Admin", "Completed", "InActive", "Deleted"],
        "ActiveProjects");

    var allSubTabItems = Areas.createTabsWithSameController("Analysis",
        ["AllFinance", "AllDates", "Schedule", "AllContracts", "AllNonPlantContracts"],
        "ActiveProjects");

    var capitalSubTabItems = Areas.createTabsWithSameController("Analysis",
        ["CapitalFinance", "CapitalDates", "CapitalSchedule","CapitalContracts", "CapitalNonPlantContracts"],
        "ActiveProjects");

    var facilitiesTabItems = Areas.createTabsWithSameController("Analysis",
        ["FacilitiesFinance", "FacilitiesDates", "FacilitiesSchedule", "FacilitiesContracts", "FacilitiesNonPlantContracts"],
        "ActiveProjects");

    var medicalTabItems = Areas.createTabsWithSameController("Analysis",
        ["MedicalFinance", "MedicalDates", "MedicalSchedule", "MedicalContracts", "MedicalNonPlantContracts"],
        "ActiveProjects");

    var housingTabItems = Areas.createTabsWithSameController("Analysis",
        ["HousingFinance", "HousingDates", "HousingSchedule","HousingContracts", "HousingNonPlantContracts"],
        "ActiveProjects");

    var realestateTabItems = Areas.createTabsWithSameController("Analysis",
        ["RealEstateFinance", "RealEstateDates", "RealEstateSchedule", "RealEstateContracts", "RealEstateNonPlantContracts"],
        "ActiveProjects");

    var otherTabItems = Areas.createTabsWithSameController("Analysis",
        ["OtherFinance", "OtherDates", "OtherContracts", "OtherNonPlantContracts"],
        "ActiveProjects");

    var onholdTabItems = Areas.createTabsWithSameController("Analysis",
        ["OnHoldFinance", "OnHoldDates", "OnHoldContracts", "OnHoldNonPlantContracts"],
        "ActiveProjects");

    var inactiveTabItems = Areas.createTabsWithSameController("Analysis",
        ["InActiveFinance", "InActiveDates", "InActiveContracts", "InActiveNonPlantContracts"],
        "ActiveProjects");

    var adminTabItems = Areas.createTabsWithSameController("Analysis",
        ["AdminFinance", "AdminDates", "AdminContracts", "AdminNonPlantContracts"],
        "ActiveProjects");

    var completedTabItems = Areas.createTabsWithSameController("Analysis",
        ["CompletedFinance", "CompletedDates", "CompletedContracts", "CompletedNonPlantContracts"],
        "ActiveProjects");

    var deletedTabItems = Areas.createTabsWithSameController("Analysis",
        ["DeletedFinance", "DeletedDates", "DeletedContracts", "DeletedNonPlantContracts"],
        "ActiveProjects");

    export function activeProjectsTabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }

    export function allSubTabInitialized(params: any) {
        return Areas.tabInitialized(allSubTabItems)(params);
    }

    export function capitalSubTabInitialized(params: any) {
        return Areas.tabInitialized(capitalSubTabItems)(params);
    }

    export function facilitiesSubTabInitialized(params: any) {
        return Areas.tabInitialized(facilitiesTabItems)(params);
    }

    export function medicalSubTabInitialized(params: any) {
        return Areas.tabInitialized(medicalTabItems)(params);
    }

    export function housingSubTabInitialized(params: any) {
        return Areas.tabInitialized(housingTabItems)(params);
    }

    export function realestateSubTabInitialized(params: any) {
        return Areas.tabInitialized(realestateTabItems)(params);
    }

    export function otherSubTabInitialized(params: any) {
        return Areas.tabInitialized(otherTabItems)(params);
    }

    export function onholdSubTabInitialized(params: any) {
        return Areas.tabInitialized(onholdTabItems)(params);
    }

    export function inactiveSubTabInitialized(params: any) {
        return Areas.tabInitialized(inactiveTabItems)(params);
    }

    export function adminSubTabInitialized(params: any) {
        return Areas.tabInitialized(adminTabItems)(params);
    }

    export function completedSubTabInitialized(params: any) {
        return Areas.tabInitialized(completedTabItems)(params);
    }

    export function deletedSubTabInitialized(params: any) {
        return Areas.tabInitialized(deletedTabItems)(params);
    }

    export function onCellPrepared(e: any) {
        if (e.rowType !== "data") {
            return;
        }
        setPifPafAmountBackground(e);
        setCIBAmountBackground(e);
    }

    function setPifPafAmountBackground(e) {
        var isPifPafDataCell = e.column.dataField === "pifpafAmount";

        if (isPifPafDataCell) {
            if (e.data.pifpafBalance < 0) {
                e.cellElement.css("background-color", "yellow");
            } else if (e.data.pifpafAmount < e.data.cibBudgetAmount) {
                e.cellElement.css("background-color", "yellow");
            }
        }
    }

    function setCIBAmountBackground(e) {
        var isCIBDataCell = e.column.dataField === "cibBudgetAmount";

        if (isCIBDataCell) {
            if (e.data.cibBudgetAmount < e.data.pifpafAmount && e.data.pifpafAmount > 1000000) {
                e.cellElement.css("background-color", "#FFA07A");
            } else if (e.data.cibBudgetAmount < e.data.appropriation && e.data.appropriation > 1000000) {
                e.cellElement.css("background-color", "red");
            }
        }
    }

    //function setStatusCellBackground(e) {
    //    var isStatusDataCell = e.column.dataField === "status";

    //    if (isStatusDataCell) {
    //        if (e.data.status === 'Approved') {
    //            e.cellElement.css('background-color', '#90EE90');
    //        } else if (e.data.status === 'HOLD') {
    //            e.cellElement.css('background-color', 'yellow');
    //        } else if (e.data.status === 'DELETED') {
    //            e.cellElement.css('background-color', 'red');
    //        }
    //    }
    //}

    export function contractViewLink(cellElement: any, cellInfo: any) {
        let linkInfo = "<a href= 'https://contract.capnet.ucla.edu/Contract/GeneralInfo/View/{placeholder}' target=\"_blank\">View</a>";

        buildCellContent(cellElement,
            () => { return cellInfo.data.contractId; },
            linkInfo);
    }

    export function projectViewLink(cellElement: any, cellInfo: any) {
        let linkInfo = "<a href= '/Account/Profile/View/{placeholder}' target=\"_blank\">View</a>";

        buildCellContent(cellElement,
            () => { return cellInfo.data.accountId; },
            linkInfo);
    }

    export function goToAccount(e: any) {
        const grid = $("#ActiveProjectsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = row[0].accountId;
            let linkInfo = "/Account/Profile/View/" + id;
            window.open(linkInfo);
        }
    }

    export function goToProject(e: any) {
        const grid = $("#ActiveProjectsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = row[0].accountId;
            let linkInfo = "/Account/Profile/View/" + id;
            window.open(linkInfo);
        }
    }

    export function goToSharePoint(e: any) {
        const grid = $("#ActiveProjectsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var sharePointLink = row[0].sharePointLink;
            let linkInfo = "https://ucla.sharepoint.com/sites/CapitalPrograms/ActiveProjects/" + sharePointLink + "/";
            if (sharePointLink != "") {
                window.open(linkInfo);
            }
            else {
                window.open("https://ucla.sharepoint.com/sites/CapitalPrograms/ActiveProjectsList");
            }
        }
    }

    export function goToPIFPAF(e: any) {
        const grid = $("#ActiveProjectsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = row[0].projectInfoId;
            let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + id + "";
            if (id != null) {
                window.open(linkInfo);
            }
        }
    }

    export function goToContract(e: any) {
        const grid = $("#ActiveProjectsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = row[0].contractId;
            let linkInfo = "https://contract.capnet.ucla.edu/Contract/GeneralInfo/View/" + id + "";
            if (id != null) {
                window.open(linkInfo);
            }
        }
    }

    export function goToConstructionContract(e: any) {
        const grid = $("#ActiveProjectsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var accountId = row[0].accountId;

            if (accountId != null) {
                const url = `/Analysis/ActiveProjects/GetConstructionContract/${accountId}`;

                $.get(url, (contractId) => {
                    if (contractId > 0) {
                        let linkInfo = "https://contract.capnet.ucla.edu/Contract/GeneralInfo/View/" + contractId + "";
                        window.open(linkInfo);
                    } else {
                        DevExpress.ui.notify("There is no construction contract for this Project", "warning", 2000);
                    }
                });
            }

     
        }
    }




}